export default __webpack_public_path__ + "static/media/virtual-tour-slide-3-tablet.f5748c44.png";